
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"scale(1.25)"}},[_c('path',{attrs:{"d":"M0.057 19.2l1.35-4.95c-0.833-1.442-1.271-3.076-1.271-4.75 0.002-5.25 4.272-9.52 9.523-9.52 2.55 0.001 4.95 0.99 6.75 2.787 1.8 1.8 2.787 4.2 2.787 6.75-0.002 5.25-4.273 9.52-9.523 9.52-1.59-0.001-3.16-0.4-4.55-1.15l-5.04 1.32zm5.28-3.05c1.34 0.8 2.62 1.28 4.31 1.28 4.35 0 7.9-3.53 7.9-7.87 0.002-4.35-3.53-7.89-7.87-7.89-4.35 0-7.9 3.53-7.9 7.87-0.001 1.77 0.52 3.1 1.4 4.5l-0.8 2.91 3.06-0.8zm9.33-4.37c-0.06-0.1-0.22-0.16-0.47-0.28-0.24-0.12-1.44-0.71-1.67-0.79-0.23-0.08-0.39-0.12-0.54 0.12-0.16 0.24-0.63 0.79-0.77 0.95-0.14 0.16-0.28 0.18-0.53 0.06-0.24-0.12-1.03-0.38-1.96-1.03-0.72-0.66-1.21-1.47-1.36-1.72-0.14-0.24-0.015-0.38 0.09-0.51 0.11-0.11 0.24-0.28 0.36-0.42 0.12-0.14 0.16-0.24 0.24-0.4 0.08-0.16 0.04-0.3-0.02-0.42-0.06-0.12-0.55-1.31-0.77-1.78-0.19-0.4-0.39-0.41-0.54-0.42l-0.46-0.01c-0.16 0-0.42 0.06-0.64 0.3-0.23 0.24-0.88 0.82-0.88 2 0 1.18 0.89 2.33 1.01 2.49 0.12 0.16 1.71 2.67 4.22 3.63 1.97 0.78 2.37 0.62 2.79 0.58 0.43-0.04 1.38-0.56 1.57-1.1 0.19-0.54 0.19-1 0.13-1.1z"}})])])
          )
        }
      }
    